import {
  Badge,
  Box,
  Button,
  Flex,
  HStack,
  SimpleGrid,
  Tabs,
  Text,
  VStack
} from "@chakra-ui/react";
import { AgGridReact } from "ag-grid-react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { useEffect, useState } from "react";
import {
  MapContainer,
  Marker,
  Polyline,
  Popup,
  TileLayer
} from "react-leaflet";
import { AdsTab, HubSpotTab } from "./CustomerDetail";
import LocationTimeline from "./LocationTimeline";

// Import AG Grid Enterprise and register modules

// Mock ad campaigns data - Canadian Real Estate focused
const mockAdCampaigns = [
  {
    id: 1,
    campaignName: "Toronto Condos - Downtown",
    adsetName: "First-Time Buyers 25-40",
    adName: "Downtown Living Video Tour",
    platform: "FB",
    status: "Converted",
    clicks: 12,
    impressions: 1850,
    adSpend: 285.5,
    firstClick: "Nov 5, 2025",
    ctr: "0.65%"
  },
  {
    id: 2,
    campaignName: "GTA Homes - Fall Campaign",
    adsetName: "Interest - Home Buyers",
    adName: "Dream Home Carousel",
    platform: "IG",
    status: "Engaged",
    clicks: 18,
    impressions: 2340,
    adSpend: 420.75,
    firstClick: "Oct 28, 2025",
    ctr: "0.77%"
  },
  {
    id: 3,
    campaignName: "Mississauga Listings",
    adsetName: "Retargeting - Website Visitors",
    adName: "New Listings Story Ad",
    platform: "IG",
    status: "Viewed",
    clicks: 8,
    impressions: 1560,
    adSpend: 195.4,
    firstClick: "Oct 22, 2025",
    ctr: "0.51%"
  },
  {
    id: 4,
    campaignName: "Pre-Construction Vaughan",
    adsetName: "High Income 35-55",
    adName: "Investment Opportunity Banner",
    platform: "FB",
    status: "Impression Only",
    clicks: 0,
    impressions: 980,
    adSpend: 145.2,
    firstClick: null,
    ctr: "0%"
  },
  {
    id: 5,
    campaignName: "Luxury Homes - Yorkville",
    adsetName: "Custom Audience - High Net Worth",
    adName: "Luxury Property Showcase",
    platform: "FB",
    status: "Engaged",
    clicks: 6,
    impressions: 890,
    adSpend: 510.3,
    firstClick: "Nov 1, 2025",
    ctr: "0.67%"
  },
  {
    id: 6,
    campaignName: "First-Time Buyer Program",
    adsetName: "Lookalike - Recent Inquiries",
    adName: "Education Video Series",
    platform: "IG",
    status: "Converted",
    clicks: 24,
    impressions: 3120,
    adSpend: 380.25,
    firstClick: "Oct 18, 2025",
    ctr: "0.77%"
  },
  {
    id: 7,
    campaignName: "Waterfront Properties",
    adsetName: "Interest - Luxury Lifestyle",
    adName: "Lake View Homes Reel",
    platform: "IG",
    status: "Viewed",
    clicks: 9,
    impressions: 1450,
    adSpend: 295.8,
    firstClick: "Nov 3, 2025",
    ctr: "0.62%"
  },
  {
    id: 8,
    campaignName: "Family Homes - North York",
    adsetName: "Parents 30-50 Toronto",
    adName: "School District Highlight",
    platform: "FB",
    status: "Engaged",
    clicks: 15,
    impressions: 2200,
    adSpend: 325.9,
    firstClick: "Oct 25, 2025",
    ctr: "0.68%"
  },
  {
    id: 9,
    campaignName: "Investment Properties GTA",
    adsetName: "Geographic - Toronto Metro",
    adName: "ROI Calculator Video",
    platform: "FB",
    status: "Viewed",
    clicks: 7,
    impressions: 1680,
    adSpend: 245.25,
    firstClick: "Oct 30, 2025",
    ctr: "0.42%"
  },
  {
    id: 10,
    campaignName: "Oakville Luxury Estates",
    adsetName: "Behavior - High-End Shoppers",
    adName: "Estate Living Photo Series",
    platform: "IG",
    status: "Converted",
    clicks: 11,
    impressions: 1340,
    adSpend: 465.0,
    firstClick: "Nov 6, 2025",
    ctr: "0.82%"
  },
  {
    id: 11,
    campaignName: "Townhomes - Markham",
    adsetName: "Interest - New Developments",
    adName: "Modern Living Carousel",
    platform: "FB",
    status: "Engaged",
    clicks: 13,
    impressions: 1920,
    adSpend: 285.4,
    firstClick: "Nov 2, 2025",
    ctr: "0.68%"
  },
  {
    id: 12,
    campaignName: "Downtown Toronto Rentals",
    adsetName: "Retargeting - Lead Magnets",
    adName: "Available Now Stories",
    platform: "IG",
    status: "Viewed",
    clicks: 5,
    impressions: 1120,
    adSpend: 165.6,
    firstClick: "Oct 27, 2025",
    ctr: "0.45%"
  }
];

// Mock HubSpot contact data
const mockHubSpotData = {
  contact: {
    id: "hs_contact_12345",
    firstName: "Daniel",
    lastName: "Rivera",
    email: "d_rivera.consulting@example.com",
    phone: "+1 (647) 318-4927",
    company: "Shopify",
    jobTitle: "Marketing Manager",
    industry: "Technology",
    leadScore: 85,
    lifecycleStage: "opportunity",
    leadStatus: "qualified",
    hubspotOwner: "Emily Carter",
    created: "2024-01-10T14:30:00Z",
    lastActivity: "2024-01-15T16:45:00Z",
    totalRevenue: 0,
    annualRevenue: 250000
  },
  deals: [
    {
      id: "deal_001",
      name: "Home Purchase Consultation",
      stage: "qualified-to-buy",
      amount: 750000,
      closeDate: "2024-02-15",
      probability: 75,
      source: "Facebook Ads",
      created: "2024-01-15T09:30:00Z",
      lastModified: "2024-01-20T11:15:00Z",
      owner: "James Mitchell"
    }
  ],
  activities: [
    {
      id: "activity_001",
      type: "email",
      subject: "Welcome to Zown - Let's Get Started!",
      direction: "outbound",
      status: "sent",
      timestamp: "2024-01-15T10:30:00Z",
      owner: "Sarah Johnson"
    },
    {
      id: "activity_002",
      type: "call",
      subject: "Initial Qualification Call",
      direction: "outbound",
      status: "completed",
      duration: "25 minutes",
      outcome: "qualified_lead",
      timestamp: "2024-01-18T14:00:00Z",
      owner: "James Mitchell",
      notes: "Customer interested in downtown condos, pre-approved for $800k"
    },
    {
      id: "activity_003",
      type: "meeting",
      subject: "Property Viewing Consultation",
      status: "scheduled",
      timestamp: "2024-01-25T15:00:00Z",
      owner: "James Mitchell",
      location: "Zown Office"
    },
    {
      id: "activity_004",
      type: "email",
      subject: "Property Recommendations",
      direction: "outbound",
      status: "sent",
      timestamp: "2024-01-22T09:15:00Z",
      owner: "Sarah Johnson"
    }
  ],
  properties: {
    budget: "$700,000 - $800,000",
    propertyType: "Condominium",
    location: "Downtown, Midtown",
    timeframe: "3-6 months",
    financing: "Pre-approved",
    creditScore: "740-760",
    downPayment: "20%",
    currentHousing: "Renting"
  }
};

// Mock HTTP request journey data
const mockJourneyData = [
  {
    timestamp: "2024-01-15T09:23:15Z",
    type: "page_visit",
    url: "/landing-page",
    method: "GET",
    userAgent: "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7)",
    referrer: "https://facebook.com/ads",
    sessionId: "sess_123456",
    ipAddress: "192.168.1.100"
  },
  {
    timestamp: "2024-01-15T09:24:32Z",
    type: "form_interaction",
    url: "/landing-page",
    method: "POST",
    action: "email_capture",
    data: { email: "john.doe@example.com" },
    sessionId: "sess_123456"
  },
  {
    timestamp: "2024-01-15T09:25:18Z",
    type: "page_visit",
    url: "/get-started",
    method: "GET",
    sessionId: "sess_123456"
  },
  {
    timestamp: "2024-01-15T09:27:45Z",
    type: "api_call",
    url: "/api/qualification/start",
    method: "POST",
    status: 200,
    responseTime: "245ms",
    sessionId: "sess_123456"
  },
  {
    timestamp: "2024-01-15T09:35:12Z",
    type: "form_submission",
    url: "/qualification-form",
    method: "POST",
    action: "submit_qualification",
    data: { income: 75000, savings: 25000, credit_score: "good" },
    sessionId: "sess_123456"
  },
  {
    timestamp: "2024-01-15T09:36:08Z",
    type: "api_call",
    url: "/api/qualification/process",
    method: "POST",
    status: 200,
    responseTime: "1.2s",
    sessionId: "sess_123456"
  },
  {
    timestamp: "2024-01-15T09:37:22Z",
    type: "page_visit",
    url: "/results",
    method: "GET",
    sessionId: "sess_123456"
  },
  {
    timestamp: "2024-01-15T09:42:15Z",
    type: "button_click",
    url: "/results",
    action: "schedule_consultation",
    sessionId: "sess_123456"
  }
];

// Mock Calendly booking data
const mockCalendlyData = [
  {
    id: "cal_001",
    eventType: "Initial Consultation",
    scheduledTime: "2024-01-20T14:00:00Z",
    duration: 30,
    status: "scheduled",
    attendeeEmail: "john.doe@example.com",
    attendeeName: "John Doe",
    calendlyUrl: "https://calendly.com/zown/consultation",
    meetingUrl: "https://zoom.us/j/123456789",
    notes: "First-time buyer interested in downtown condos",
    createdAt: "2024-01-15T09:42:30Z"
  },
  {
    id: "cal_002",
    eventType: "Follow-up Call",
    scheduledTime: "2024-01-25T16:30:00Z",
    duration: 15,
    status: "completed",
    attendeeEmail: "john.doe@example.com",
    attendeeName: "John Doe",
    calendlyUrl: "https://calendly.com/zown/followup",
    meetingUrl: "https://zoom.us/j/987654321",
    notes: "Review qualification results and next steps",
    createdAt: "2024-01-22T11:15:00Z",
    completedAt: "2024-01-25T16:30:00Z"
  },
  {
    id: "cal_003",
    eventType: "Property Viewing",
    scheduledTime: "2024-02-01T10:00:00Z",
    duration: 60,
    status: "cancelled",
    attendeeEmail: "john.doe@example.com",
    attendeeName: "John Doe",
    calendlyUrl: "https://calendly.com/zown/property-viewing",
    notes: "Viewing 3 downtown condos",
    createdAt: "2024-01-26T09:30:00Z",
    cancelledAt: "2024-01-30T14:20:00Z",
    cancellationReason: "Rescheduled by client"
  }
];

interface CustomerDetailModelProps {
  isOpen: boolean;
  onClose: () => void;
  customer: any;
}

// Multiple journey data sets for different customers
const journeyDataSets = [
  // Journey Set 1 - East Toronto
  [
    { ip: "74.125.224.72", city: "Leslieville", country: "Toronto", lat: 43.6629, lng: -79.3262, requests: 9, timestamp: "2025-11-08T07:45:00Z", step: 1 },
    { ip: "142.250.185.14", city: "The Beaches", country: "Toronto", lat: 43.6677, lng: -79.2941, requests: 14, timestamp: "2025-11-08T09:20:00Z", step: 2 },
    { ip: "216.58.217.110", city: "Danforth", country: "Toronto", lat: 43.6763, lng: -79.3498, requests: 6, timestamp: "2025-11-08T10:15:00Z", step: 3 },
    { ip: "172.217.14.99", city: "Riverdale", country: "Toronto", lat: 43.6686, lng: -79.3469, requests: 11, timestamp: "2025-11-08T11:50:00Z", step: 4 },
    { ip: "64.233.185.101", city: "Corktown", country: "Toronto", lat: 43.6544, lng: -79.3592, requests: 8, timestamp: "2025-11-08T13:10:00Z", step: 5 },
  ],
  // Journey Set 2 - West Toronto
  [
    { ip: "98.137.246.8", city: "High Park", country: "Toronto", lat: 43.6465, lng: -79.4637, requests: 7, timestamp: "2025-11-09T08:15:00Z", step: 1 },
    { ip: "74.6.231.21", city: "Roncesvalles", country: "Toronto", lat: 43.6482, lng: -79.4536, requests: 12, timestamp: "2025-11-09T09:45:00Z", step: 2 },
    { ip: "66.196.80.143", city: "Parkdale", country: "Toronto", lat: 43.6391, lng: -79.4438, requests: 5, timestamp: "2025-11-09T11:00:00Z", step: 3 },
    { ip: "209.191.122.70", city: "Liberty Village", country: "Toronto", lat: 43.6368, lng: -79.4197, requests: 9, timestamp: "2025-11-09T12:30:00Z", step: 4 },
    { ip: "72.30.35.10", city: "Queen West", country: "Toronto", lat: 43.6476, lng: -79.4116, requests: 11, timestamp: "2025-11-09T14:15:00Z", step: 5 },
    { ip: "98.136.103.24", city: "Trinity Bellwoods", country: "Toronto", lat: 43.6467, lng: -79.4182, requests: 6, timestamp: "2025-11-09T15:40:00Z", step: 6 },
  ],
  // Journey Set 3 - Downtown Core
  [
    { ip: "173.194.222.91", city: "Financial District", country: "Toronto", lat: 43.6426, lng: -79.3871, requests: 15, timestamp: "2025-11-10T09:00:00Z", step: 1 },
    { ip: "216.239.38.21", city: "Entertainment District", country: "Toronto", lat: 43.6465, lng: -79.3871, requests: 8, timestamp: "2025-11-10T10:30:00Z", step: 2 },
    { ip: "64.233.177.99", city: "King West", country: "Toronto", lat: 43.6441, lng: -79.3957, requests: 10, timestamp: "2025-11-10T11:45:00Z", step: 3 },
    { ip: "172.217.165.110", city: "St. Lawrence Market", country: "Toronto", lat: 43.6487, lng: -79.3716, requests: 7, timestamp: "2025-11-10T13:20:00Z", step: 4 },
    { ip: "142.250.80.46", city: "Distillery District", country: "Toronto", lat: 43.6503, lng: -79.3598, requests: 13, timestamp: "2025-11-10T15:00:00Z", step: 5 },
    { ip: "209.85.146.83", city: "Harbourfront", country: "Toronto", lat: 43.6389, lng: -79.3815, requests: 4, timestamp: "2025-11-10T16:30:00Z", step: 6 },
    { ip: "74.125.200.94", city: "Toronto Islands Ferry", country: "Toronto", lat: 43.6275, lng: -79.3762, requests: 3, timestamp: "2025-11-10T17:45:00Z", step: 7 },
  ],
  // Journey Set 4 - North Toronto
  [
    { ip: "184.72.104.138", city: "Yorkville", country: "Toronto", lat: 43.6708, lng: -79.3899, requests: 11, timestamp: "2025-11-11T10:00:00Z", step: 1 },
    { ip: "54.239.28.85", city: "The Annex", country: "Toronto", lat: 43.6689, lng: -79.4051, requests: 8, timestamp: "2025-11-11T11:30:00Z", step: 2 },
    { ip: "205.251.242.103", city: "Casa Loma", country: "Toronto", lat: 43.6780, lng: -79.4094, requests: 6, timestamp: "2025-11-11T13:00:00Z", step: 3 },
    { ip: "52.94.236.248", city: "Forest Hill", country: "Toronto", lat: 43.6926, lng: -79.4134, requests: 9, timestamp: "2025-11-11T14:45:00Z", step: 4 },
    { ip: "99.84.191.139", city: "Lawrence Park", country: "Toronto", lat: 43.7235, lng: -79.4063, requests: 5, timestamp: "2025-11-11T16:15:00Z", step: 5 },
  ],
  // Journey Set 5 - Midtown
  [
    { ip: "151.101.1.69", city: "Yonge & Eglinton", country: "Toronto", lat: 43.7066, lng: -79.3985, requests: 13, timestamp: "2025-11-12T08:30:00Z", step: 1 },
    { ip: "104.16.123.96", city: "Mount Pleasant", country: "Toronto", lat: 43.7045, lng: -79.3867, requests: 7, timestamp: "2025-11-12T10:00:00Z", step: 2 },
    { ip: "172.67.182.31", city: "Davisville", country: "Toronto", lat: 43.6987, lng: -79.3931, requests: 10, timestamp: "2025-11-12T11:45:00Z", step: 3 },
    { ip: "188.114.97.3", city: "Summerhill", country: "Toronto", lat: 43.6818, lng: -79.3946, requests: 6, timestamp: "2025-11-12T13:30:00Z", step: 4 },
    { ip: "104.18.32.68", city: "Rosedale", country: "Toronto", lat: 43.6786, lng: -79.3769, requests: 8, timestamp: "2025-11-12T15:15:00Z", step: 5 },
    { ip: "162.159.135.42", city: "Cabbagetown", country: "Toronto", lat: 43.6676, lng: -79.3647, requests: 4, timestamp: "2025-11-12T16:50:00Z", step: 6 },
  ],
  // Journey Set 6 - Scarborough
  [
    { ip: "23.227.38.65", city: "Scarborough Town Centre", country: "Toronto", lat: 43.7764, lng: -79.2577, requests: 9, timestamp: "2025-11-13T09:15:00Z", step: 1 },
    { ip: "104.154.127.89", city: "Birch Cliff", country: "Toronto", lat: 43.6923, lng: -79.2642, requests: 6, timestamp: "2025-11-13T10:45:00Z", step: 2 },
    { ip: "35.186.224.25", city: "Cliffside", country: "Toronto", lat: 43.7056, lng: -79.2397, requests: 11, timestamp: "2025-11-13T12:20:00Z", step: 3 },
    { ip: "34.102.136.180", city: "Guildwood", country: "Toronto", lat: 43.7445, lng: -79.1956, requests: 5, timestamp: "2025-11-13T14:00:00Z", step: 4 },
  ],
  // Journey Set 7 - Etobicoke
  [
    { ip: "13.107.42.14", city: "Mimico", country: "Toronto", lat: 43.6172, lng: -79.4932, requests: 8, timestamp: "2025-11-14T08:00:00Z", step: 1 },
    { ip: "204.79.197.200", city: "New Toronto", country: "Toronto", lat: 43.6053, lng: -79.5099, requests: 12, timestamp: "2025-11-14T09:30:00Z", step: 2 },
    { ip: "40.76.4.15", city: "Long Branch", country: "Toronto", lat: 43.5961, lng: -79.5401, requests: 7, timestamp: "2025-11-14T11:15:00Z", step: 3 },
    { ip: "52.109.12.20", city: "Humber Bay", country: "Toronto", lat: 43.6235, lng: -79.4763, requests: 10, timestamp: "2025-11-14T13:00:00Z", step: 4 },
    { ip: "20.190.151.68", city: "Islington Village", country: "Toronto", lat: 43.6448, lng: -79.5223, requests: 6, timestamp: "2025-11-14T14:45:00Z", step: 5 },
    { ip: "131.253.33.215", city: "The Kingsway", country: "Toronto", lat: 43.6574, lng: -79.5097, requests: 9, timestamp: "2025-11-14T16:20:00Z", step: 6 },
  ],
];

// Get journey data based on customer identifier
const getJourneyDataForCustomer = (customer: any) => {
  if (!customer) return journeyDataSets[0];
  // Use customer email or zid to deterministically select a journey set
  const identifier = customer.emailAddress || customer.email || customer.zid || "";
  let hash = 0;
  for (let i = 0; i < identifier.length; i++) {
    hash = ((hash << 5) - hash) + identifier.charCodeAt(i);
    hash = hash & hash;
  }
  const index = Math.abs(hash) % journeyDataSets.length;
  return journeyDataSets[index];
};

function CustomerDetailModel({
  isOpen,
  onClose,
  customer
}: CustomerDetailModelProps) {
  const [selectedCustomer, setSelectedCustomer] = useState<any>(customer);
  const [activeTab, setActiveTab] = useState<string>("summary");
  const [_currentPage, setCurrentPage] = useState(1);
  const [_pageSize] = useState(5);
  
  // Sync selectedCustomer with customer prop when it changes
  useEffect(() => {
    if (customer) {
      setSelectedCustomer(customer);
    }
  }, [customer]);
  
  // Get journey data for the selected customer
  const journeyPoints = getJourneyDataForCustomer(selectedCustomer);

  // Add CSS animations
  useEffect(() => {
    const style = document.createElement("style");
    style.textContent = `
      @keyframes ping {
        0% { transform: scale(1); opacity: 1; }
        75%, 100% { transform: scale(1.5); opacity: 0; }
      }
      @keyframes pulse {
        0%, 100% { opacity: 0.6; }
        50% { opacity: 0.3; }
      }
      @keyframes shimmer {
        0% { transform: translateX(-100%); }
        100% { transform: translateX(100%); }
      }
      @keyframes slide-down {
        0% { transform: translateY(-100%); }
        100% { transform: translateY(100%); }
      }
      @keyframes float {
        0%, 100% { transform: translateY(0); }
        50% { transform: translateY(-10px); }
      }
      @keyframes bounce {
        0%, 100% { transform: translateY(0); }
        50% { transform: translateY(-10px); }
      }
    `;
    document.head.appendChild(style);
    return () => {
      document.head.removeChild(style);
    };
  }, []);

  // Handle Escape key press
  useEffect(() => {
    const handleEscapeKey = (event: KeyboardEvent) => {
      if (event.key === "Escape" && isOpen) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener("keydown", handleEscapeKey);
    }

    return () => {
      document.removeEventListener("keydown", handleEscapeKey);
    };
  }, [isOpen, onClose]);

  // Utility functions
  const getStatusColor = (status: string) => {
    switch (status) {
      case "QUALIFIED":
        return "green";
      case "PENDING":
        return "yellow";
      case "NOT_QUALIFIED":
        return "red";
      default:
        return "gray";
    }
  };

  const getStageColor = (stage: string) => {
    switch (stage) {
      case "COMPLETED":
        return "green";
      case "CONGRATULATIONS":
        return "blue";
      case "IN_PROGRESS":
        return "orange";
      default:
        return "gray";
    }
  };

  const formatTimestamp = (timestamp: string) => {
    const date = new Date(timestamp);
    return {
      date: date.toLocaleDateString(),
      time: date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }),
      full: date.toLocaleString()
    };
  };

  const getJourneyEventStyle = (type: string) => {
    switch (type) {
      case "page_visit":
        return {
          icon: "🌐",
          color: "blue.500",
          bg: "blue.50",
          borderColor: "blue.200",
          title: "Page Visit",
          description: "User navigated to a page"
        };
      case "form_interaction":
        return {
          icon: "✏️",
          color: "green.500",
          bg: "green.50",
          borderColor: "green.200",
          title: "Form Interaction",
          description: "User interacted with form fields"
        };
      case "form_submission":
        return {
          icon: "📤",
          color: "green.600",
          bg: "green.100",
          borderColor: "green.300",
          title: "Form Submission",
          description: "User submitted form data"
        };
      case "api_call":
        return {
          icon: "⚡",
          color: "purple.500",
          bg: "purple.50",
          borderColor: "purple.200",
          title: "API Request",
          description: "Server processing request"
        };
      case "button_click":
        return {
          icon: "👆",
          color: "orange.500",
          bg: "orange.50",
          borderColor: "orange.200",
          title: "Button Click",
          description: "User clicked interactive element"
        };
      default:
        return {
          icon: "📍",
          color: "gray.500",
          bg: "gray.50",
          borderColor: "gray.200",
          title: "Event",
          description: "System event"
        };
    }
  };

  const getCalendlyStatusColor = (status: string) => {
    switch (status) {
      case "scheduled":
        return "blue";
      case "completed":
        return "green";
      case "cancelled":
        return "red";
      default:
        return "gray";
    }
  };

  const createNumberedIcon = (
    number: number,
    isStart = false,
    isEnd = false
  ) => {
    const color = isStart ? "#22C55E" : isEnd ? "#EF4444" : "#3B82F6";
    const textColor = "#FFFFFF";

    return L.divIcon({
      html: `
        <div style="
          width: 30px;
          height: 30px;
          border-radius: 50%;
          background-color: ${color};
          border: 3px solid white;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: bold;
          font-size: 14px;
          color: ${textColor};
          box-shadow: 0 2px 4px rgba(0,0,0,0.3);
        ">
          ${number}
        </div>
      `,
      className: "custom-div-icon",
      iconSize: [30, 30],
      iconAnchor: [15, 15],
      popupAnchor: [0, -15]
    });
  };

  if (!isOpen) {
    return null;
  }

  return (
    <Box
      position="fixed"
      top={0}
      left={0}
      right={0}
      bottom={0}
      bg="blackAlpha.700"
      zIndex={10000}
      display="flex"
      alignItems="center"
      justifyContent="center"
      p={{ base: 0, md: 4, lg: 6 }}
      style={{ isolation: "isolate" }}
    >
      {/* Modal Content */}
      <Box
        bg="white"
        w="full"
        h="full"
        maxW={{ base: "100%", xl: "95vw" }}
        maxH={{ base: "100%", xl: "95vh" }}
        overflow="hidden"
        display="flex"
        flexDirection="column"
        rounded={{ base: "none", md: "xl" }}
        shadow="2xl"
        position="relative"
        zIndex={10000}
      >
        {/* Close Button - Floating */}
        <Button
          onClick={onClose}
          position="absolute"
          top={4}
          right={4}
          zIndex={10001}
          size="md"
          variant="solid"
          colorScheme="gray"
          rounded="full"
          shadow="lg"
          _hover={{
            transform: "scale(1.05)",
            shadow: "xl"
          }}
          transition="all 0.2s"
        >
          <Text fontSize="lg" fontWeight="bold">
            ✕
          </Text>
        </Button>

        {/* Modal Header */}
        <Box
          p={6}
          pb={4}
          borderBottom="2px"
          borderColor="gray.100"
          bg="gray.50"
        >
          <Flex justify="space-between" align="start" pr={12}>
            {selectedCustomer && (
              <VStack align="start" gap={2}>
                <Text fontSize="2xl" fontWeight="bold" color="gray.800">
                  {selectedCustomer.firstName} {selectedCustomer.lastName}
                </Text>
                <HStack gap={4}>
                  <Badge
                    colorScheme={getStatusColor(
                      selectedCustomer.qualificationStatus
                    )}
                    size="lg"
                    px={3}
                    py={1}
                  >
                    {selectedCustomer.qualificationStatus}
                  </Badge>
                  <Badge
                    colorScheme={getStageColor(selectedCustomer.stage)}
                    size="lg"
                    px={3}
                    py={1}
                  >
                    {selectedCustomer.stage.replace(/_/g, " ")}
                  </Badge>
                  <Text fontSize="sm" color="gray.600" fontWeight="medium">
                    Step {selectedCustomer.step}
                  </Text>
                </HStack>
              </VStack>
            )}
          </Flex>
        </Box>

        {/* Tabs Component */}
        <Tabs.Root
          value={activeTab}
          onValueChange={(e) => {
            setActiveTab(e.value);
            if (e.value === "ads") {
              setCurrentPage(1);
            }
          }}
          variant="line"
          flex="1"
          display="flex"
          flexDirection="column"
          overflow="hidden"
        >
          <Box
            bg="white"
            borderBottom="1px"
            borderColor="gray.200"
            px={6}
            shadow="sm"
          >
            <Tabs.List>
              <Tabs.Trigger value="summary">Summary</Tabs.Trigger>
              <Tabs.Trigger value="hubspot">HubSpot</Tabs.Trigger>
              <Tabs.Trigger value="journey">Journey</Tabs.Trigger>
              <Tabs.Trigger value="forms">Forms</Tabs.Trigger>
              <Tabs.Trigger value="calendly">Calendly</Tabs.Trigger>
              <Tabs.Trigger value="chain">Chain</Tabs.Trigger>
              <Tabs.Trigger value="referrals">Referrals</Tabs.Trigger>
              <Tabs.Trigger value="ads">Ads</Tabs.Trigger>
            </Tabs.List>
          </Box>
          {/* Tab Content Container */}
          <Box flex="1" overflow="hidden" bg="gray.50">
            {/* HubSpot Tab Content */}
            <Tabs.Content value="hubspot" asChild>
              <Box h="100%" overflowY="auto" p={6}>
                <HubSpotTab
                  contact={mockHubSpotData.contact}
                  deals={mockHubSpotData.deals}
                  activities={mockHubSpotData.activities}
                  properties={mockHubSpotData.properties}
                />
              </Box>
            </Tabs.Content>
            {/* Journey Tab Content */}
            <Tabs.Content value="journey" asChild>
              <Box
                h="100%"
                overflowY="auto"
                p={6}
                bg="gradient.to-br"
                bgGradient="linear(to-br, blue.50, purple.50)"
              >
                {/* Enhanced Journey Header with Stats */}
                <Box
                  mb={8}
                  p={6}
                  bg="white"
                  rounded="2xl"
                  shadow="xl"
                  border="2px"
                  borderColor="blue.200"
                  position="relative"
                  overflow="hidden"
                >
                  {/* Decorative gradient */}
                  <Box
                    position="absolute"
                    top="0"
                    right="0"
                    w="300px"
                    h="300px"
                    bg="radial-gradient(circle, rgba(99, 102, 241, 0.1) 0%, transparent 70%)"
                    transform="translate(30%, -50%)"
                  />

                  <VStack align="stretch" gap={4}>
                    <HStack justify="space-between">
                      <HStack gap={4}>
                        <Box
                          fontSize="3xl"
                          bg="gradient.to-br"
                          bgGradient="linear(to-br, blue.100, purple.100)"
                          p={3}
                          rounded="xl"
                          shadow="md"
                        >
                          🚀
                        </Box>
                        <Box>
                          <Text
                            fontWeight="bold"
                            color="gray.900"
                            fontSize="2xl"
                          >
                            Customer Journey Timeline
                          </Text>
                          <Text fontSize="md" color="gray.600">
                            Track every interaction from discovery to conversion
                          </Text>
                        </Box>
                      </HStack>

                      {/* Journey Stats Cards */}
                      <HStack gap={4}>
                        <Box
                          bg="purple.50"
                          px={4}
                          py={2}
                          rounded="lg"
                          border="1px"
                          borderColor="purple.200"
                        >
                          <Text
                            fontSize="2xl"
                            fontWeight="bold"
                            color="purple.700"
                          >
                            7
                          </Text>
                          <Text fontSize="xs" color="purple.600">
                            Total Steps
                          </Text>
                        </Box>
                        <Box
                          bg="green.50"
                          px={4}
                          py={2}
                          rounded="lg"
                          border="1px"
                          borderColor="green.200"
                        >
                          <Text
                            fontSize="2xl"
                            fontWeight="bold"
                            color="green.700"
                          >
                            100%
                          </Text>
                          <Text fontSize="xs" color="green.600">
                            Completed
                          </Text>
                        </Box>
                        <Box
                          bg="orange.50"
                          px={4}
                          py={2}
                          rounded="lg"
                          border="1px"
                          borderColor="orange.200"
                        >
                          <Text
                            fontSize="2xl"
                            fontWeight="bold"
                            color="orange.700"
                          >
                            2.5h
                          </Text>
                          <Text fontSize="xs" color="orange.600">
                            Duration
                          </Text>
                        </Box>
                      </HStack>
                    </HStack>

                    {/* Animated Progress Bar */}
                    <Box>
                      <HStack justify="space-between" mb={2}>
                        <Text
                          fontSize="sm"
                          fontWeight="medium"
                          color="gray.700"
                        >
                          Journey Progress
                        </Text>
                        <Badge colorScheme="green" fontSize="xs">
                          ✓ Complete
                        </Badge>
                      </HStack>
                      <Box
                        bg="gray.200"
                        h="10px"
                        rounded="full"
                        overflow="hidden"
                        shadow="inner"
                      >
                        <Box
                          bg="gradient.to-r"
                          bgGradient="linear(to-r, blue.400, purple.400, green.400)"
                          h="100%"
                          w="100%"
                          rounded="full"
                          position="relative"
                          boxShadow="0 2px 4px rgba(0,0,0,0.2)"
                        />
                      </Box>
                    </Box>
                  </VStack>
                </Box>

                {/* Enhanced Timeline Container */}
                <Box position="relative" pl={12}>
                  {/* Animated Gradient Timeline Line */}
                  <Box
                    position="absolute"
                    left="28px"
                    top="0"
                    bottom="0"
                    width="4px"
                    bg="gradient.to-b"
                    bgGradient="linear(to-b, blue.300, purple.300, green.300)"
                    rounded="full"
                    zIndex={0}
                    opacity={0.8}
                  />

                  <VStack align="stretch" gap={6}>
                    {mockJourneyData.map((event, index) => {
                      const style = getJourneyEventStyle(event.type);
                      const timestamp = formatTimestamp(event.timestamp);
                      const isLast = index === mockJourneyData.length - 1;

                      return (
                        <Box key={index} position="relative">
                          {/* Enhanced Timeline Node with Animation */}
                          <Box position="absolute" left="-36px" top="8px">
                            <Box
                              w={20}
                              h={20}
                              bg="white"
                              border="5px"
                              borderColor={style.color}
                              rounded="full"
                              display="flex"
                              alignItems="center"
                              justifyContent="center"
                              fontSize="2xl"
                              zIndex={2}
                              shadow="xl"
                              position="relative"
                              _hover={{
                                transform: "scale(1.2)",
                                shadow: "2xl"
                              }}
                              transition="all 0.3s"
                              cursor="pointer"
                            >
                              {style.icon}
                              {/* Pulse effect for current step */}
                              {index === 0 && (
                                <Box
                                  position="absolute"
                                  top="-5px"
                                  left="-5px"
                                  right="-5px"
                                  bottom="-5px"
                                  border="2px"
                                  borderColor={style.color}
                                  rounded="full"
                                  opacity={0.4}
                                  animation="ping 2s infinite"
                                />
                              )}
                            </Box>
                          </Box>

                          {/* Enhanced Event Card with Gradient Border */}
                          <Box
                            bg="white"
                            border="2px"
                            borderColor={style.borderColor}
                            rounded="2xl"
                            p={6}
                            shadow="lg"
                            position="relative"
                            overflow="hidden"
                            _hover={{
                              shadow: "2xl",
                              borderColor: style.color,
                              transform: "translateX(8px)"
                            }}
                            transition="all 0.3s"
                            ml={8}
                            _before={{
                              content: '""',
                              position: "absolute",
                              top: 0,
                              left: 0,
                              right: 0,
                              height: "3px",
                              bg: `linear-gradient(90deg, ${style.color}, ${style.borderColor})`
                            }}
                          >
                            {/* Card Header */}
                            <Flex justify="space-between" align="start" mb={4}>
                              <Box>
                                <Text
                                  fontSize="lg"
                                  fontWeight="bold"
                                  color={style.color}
                                  mb={1}
                                >
                                  {style.title}
                                </Text>
                                <Text fontSize="sm" color="gray.600" mb={2}>
                                  {style.description}
                                </Text>
                              </Box>
                              <Box textAlign="right">
                                <Text
                                  fontSize="sm"
                                  fontWeight="medium"
                                  color="gray.800"
                                >
                                  {timestamp.time}
                                </Text>
                                <Text fontSize="xs" color="gray.500">
                                  {timestamp.date}
                                </Text>
                              </Box>
                            </Flex>

                            {/* Main Content */}
                            <VStack align="start" gap={3}>
                              {/* URL and Method */}
                              <Box
                                bg={style.bg}
                                p={3}
                                rounded="lg"
                                w="100%"
                                border="1px"
                                borderColor={style.borderColor}
                              >
                                <HStack gap={3} mb={2}>
                                  <Badge
                                    colorScheme={
                                      event.method === "GET" ? "blue" : "green"
                                    }
                                    size="sm"
                                  >
                                    {event.method}
                                  </Badge>
                                  <Text
                                    fontSize="sm"
                                    fontFamily="mono"
                                    fontWeight="medium"
                                    color="gray.800"
                                  >
                                    {event.url}
                                  </Text>
                                </HStack>

                                {event.userAgent && (
                                  <Text
                                    fontSize="xs"
                                    color="gray.600"
                                    overflow="hidden"
                                    whiteSpace="nowrap"
                                    textOverflow="ellipsis"
                                  >
                                    <strong>User Agent:</strong>{" "}
                                    {event.userAgent}
                                  </Text>
                                )}
                              </Box>

                              {/* Action Details */}
                              {event.action && (
                                <Box
                                  bg="orange.50"
                                  p={3}
                                  rounded="lg"
                                  w="100%"
                                  border="1px"
                                  borderColor="orange.200"
                                >
                                  <HStack gap={2} mb={1}>
                                    <Box fontSize="sm">🎯</Box>
                                    <Text
                                      fontSize="sm"
                                      fontWeight="medium"
                                      color="orange.800"
                                    >
                                      User Action
                                    </Text>
                                  </HStack>
                                  <Text fontSize="sm" color="orange.700">
                                    {event.action
                                      .replace(/_/g, " ")
                                      .replace(/\b\w/g, (l) => l.toUpperCase())}
                                  </Text>
                                </Box>
                              )}

                              {/* Form Data */}
                              {event.data && (
                                <Box
                                  bg="green.50"
                                  p={4}
                                  rounded="lg"
                                  w="100%"
                                  border="1px"
                                  borderColor="green.200"
                                >
                                  <HStack gap={2} mb={3}>
                                    <Box fontSize="sm">📊</Box>
                                    <Text
                                      fontSize="sm"
                                      fontWeight="medium"
                                      color="green.800"
                                    >
                                      Submitted Data
                                    </Text>
                                  </HStack>
                                  <Box
                                    bg="white"
                                    p={3}
                                    rounded="md"
                                    border="1px"
                                    borderColor="green.300"
                                  >
                                    {Object.entries(event.data).map(
                                      ([key, value]) => (
                                        <Flex
                                          key={key}
                                          justify="space-between"
                                          py={1}
                                        >
                                          <Text
                                            fontSize="xs"
                                            fontWeight="medium"
                                            color="gray.600"
                                          >
                                            {key
                                              .replace(/_/g, " ")
                                              .replace(/\b\w/g, (l) =>
                                                l.toUpperCase()
                                              )}
                                            :
                                          </Text>
                                          <Text
                                            fontSize="xs"
                                            fontFamily="mono"
                                            color="green.700"
                                          >
                                            {typeof value === "string"
                                              ? value
                                              : JSON.stringify(value)}
                                          </Text>
                                        </Flex>
                                      )
                                    )}
                                  </Box>
                                </Box>
                              )}

                              {/* Response Status */}
                              {event.status && (
                                <HStack gap={4} w="100%">
                                  <Box
                                    bg={
                                      event.status === 200
                                        ? "green.50"
                                        : "red.50"
                                    }
                                    p={2}
                                    rounded="md"
                                    border="1px"
                                    borderColor={
                                      event.status === 200
                                        ? "green.200"
                                        : "red.200"
                                    }
                                  >
                                    <HStack gap={2}>
                                      <Text
                                        fontSize="xs"
                                        fontWeight="medium"
                                        color="gray.600"
                                      >
                                        Status:
                                      </Text>
                                      <Badge
                                        colorScheme={
                                          event.status === 200 ? "green" : "red"
                                        }
                                        size="sm"
                                      >
                                        {event.status}
                                      </Badge>
                                    </HStack>
                                  </Box>

                                  {event.responseTime && (
                                    <Box
                                      bg="purple.50"
                                      p={2}
                                      rounded="md"
                                      border="1px"
                                      borderColor="purple.200"
                                    >
                                      <HStack gap={2}>
                                        <Text
                                          fontSize="xs"
                                          fontWeight="medium"
                                          color="gray.600"
                                        >
                                          Response Time:
                                        </Text>
                                        <Text
                                          fontSize="xs"
                                          fontFamily="mono"
                                          color="purple.700"
                                        >
                                          {event.responseTime}
                                        </Text>
                                      </HStack>
                                    </Box>
                                  )}
                                </HStack>
                              )}

                              {/* Technical Details Footer */}
                              <Box
                                pt={2}
                                borderTop="1px"
                                borderColor="gray.100"
                              >
                                <HStack gap={4} fontSize="xs" color="gray.500">
                                  {event.referrer && (
                                    <Text>
                                      <strong>Referrer:</strong>{" "}
                                      {new URL(event.referrer).hostname}
                                    </Text>
                                  )}
                                  {event.sessionId && (
                                    <Text>
                                      <strong>Session:</strong>{" "}
                                      {event.sessionId}
                                    </Text>
                                  )}
                                  {event.ipAddress && (
                                    <Text>
                                      <strong>IP:</strong> {event.ipAddress}
                                    </Text>
                                  )}
                                </HStack>
                              </Box>
                            </VStack>
                          </Box>

                          {/* Progress Indicator */}
                          {!isLast && (
                            <Box
                              position="absolute"
                              left="-12px"
                              bottom="-30px"
                              fontSize="xs"
                              color="gray.400"
                              bg="white"
                              px={2}
                              py={1}
                              rounded="full"
                              border="1px"
                              borderColor="gray.200"
                              zIndex={1}
                            >
                              Step {index + 1} of {mockJourneyData.length}
                            </Box>
                          )}
                        </Box>
                      );
                    })}
                  </VStack>

                  {/* Journey Complete Badge */}
                  <Box
                    mt={8}
                    p={4}
                    bg="green.50"
                    border="2px"
                    borderColor="green.200"
                    rounded="lg"
                    textAlign="center"
                  >
                    <HStack justify="center" gap={2}>
                      <Box fontSize="lg">🎉</Box>
                      <Text fontWeight="bold" color="green.800">
                        Journey Complete
                      </Text>
                    </HStack>
                    <Text fontSize="sm" color="green.600" mt={1}>
                      Customer successfully completed the qualification process
                    </Text>
                  </Box>
                </Box>
              </Box>
            </Tabs.Content>

            {/* Forms Tab Content */}
            <Tabs.Content value="forms" asChild>
              <Box h="100%" overflowY="auto" p={6}>
                <VStack align="stretch" gap={4}>
                  {/* Mock Forms Data */}
                  {[
                    {
                      id: "form_001",
                      name: "Home Buying Assessment",
                      submittedAt: "2025-01-15T10:30:00Z",
                      status: "completed",
                      type: "assessment",
                      fields: {
                        "Current Housing": "Renting",
                        "Budget Range": "$400,000 - $500,000",
                        "Down Payment": "$80,000",
                        "Credit Score": "750+",
                        "Employment Status": "Full-time",
                        "Annual Income": "$85,000",
                        "Preferred Location": "Downtown, Suburbs",
                        "Property Type": "Single Family, Townhouse",
                        Timeline: "3-6 months",
                        "First Time Buyer": "No"
                      }
                    },
                    {
                      id: "form_002",
                      name: "Pre-Qualification Form",
                      submittedAt: "2025-01-14T14:15:00Z",
                      status: "pending_review",
                      type: "qualification",
                      fields: {
                        "Monthly Income": "$7,100",
                        "Monthly Debts": "$1,200",
                        Assets: "$120,000",
                        "Desired Loan Amount": "$420,000",
                        "Property Value": "$480,000",
                        "Loan Type": "Conventional",
                        Occupancy: "Primary Residence",
                        Purpose: "Purchase"
                      }
                    },
                    {
                      id: "form_003",
                      name: "Contact Information",
                      submittedAt: "2025-01-13T09:45:00Z",
                      status: "completed",
                      type: "contact",
                      fields: {
                        "Full Name": "John Smith",
                        Email: "john.smith@email.com",
                        Phone: "(555) 123-4567",
                        Address: "123 Main St, City, State 12345",
                        "Preferred Contact": "Email",
                        "Best Time to Call": "Evenings",
                        "How did you hear about us": "Google Search"
                      }
                    }
                  ].map((form) => {
                    const submittedTime = formatTimestamp(form.submittedAt);

                    const getFormStatusColor = (status: string) => {
                      switch (status) {
                        case "completed":
                          return "green";
                        case "pending_review":
                          return "orange";
                        case "in_progress":
                          return "blue";
                        case "draft":
                          return "gray";
                        default:
                          return "gray";
                      }
                    };

                    const getFormTypeIcon = (type: string) => {
                      switch (type) {
                        case "assessment":
                          return "[ASSESSMENT]";
                        case "qualification":
                          return "[QUALIFICATION]";
                        case "contact":
                          return "[CONTACT]";
                        case "application":
                          return "[APPLICATION]";
                        default:
                          return "[FORM]";
                      }
                    };

                    return (
                      <Box
                        key={form.id}
                        p={4}
                        border="1px"
                        borderColor="gray.200"
                        rounded="lg"
                        bg="white"
                      >
                        <Flex justify="space-between" align="start" mb={3}>
                          <VStack align="start" gap={1}>
                            <HStack>
                              <Text
                                fontSize="lg"
                                fontWeight="bold"
                                color="gray.800"
                              >
                                {getFormTypeIcon(form.type)} {form.name}
                              </Text>
                              <Badge
                                colorScheme={getFormStatusColor(form.status)}
                                variant="subtle"
                                size="sm"
                              >
                                {form.status.replace("_", " ").toUpperCase()}
                              </Badge>
                            </HStack>
                            <Text fontSize="sm" color="gray.600">
                              Submitted: {submittedTime.full}
                            </Text>
                            <Text fontSize="xs" color="gray.500">
                              Form ID: {form.id}
                            </Text>
                          </VStack>
                        </Flex>

                        {/* Form Fields */}
                        <Box mt={4}>
                          <Text
                            fontSize="sm"
                            fontWeight="semibold"
                            color="gray.700"
                            mb={2}
                          >
                            Form Data:
                          </Text>
                          <SimpleGrid columns={2} gap={3}>
                            {Object.entries(form.fields).map(([key, value]) => (
                              <Box key={key}>
                                <Text
                                  fontSize="xs"
                                  color="gray.600"
                                  fontWeight="medium"
                                >
                                  {key}:
                                </Text>
                                <Text fontSize="sm" color="gray.800">
                                  {value}
                                </Text>
                              </Box>
                            ))}
                          </SimpleGrid>
                        </Box>
                      </Box>
                    );
                  })}
                </VStack>
              </Box>
            </Tabs.Content>

            {/* Calendly Tab Content */}
            <Tabs.Content value="calendly" asChild>
              <Box h="100%" overflowY="auto" p={6}>
                <VStack align="stretch" gap={4}>
                  {mockCalendlyData.map((booking) => {
                    const scheduledTime = formatTimestamp(
                      booking.scheduledTime
                    );
                    const createdTime = formatTimestamp(booking.createdAt);

                    return (
                      <Box
                        key={booking.id}
                        p={4}
                        border="1px"
                        borderColor="gray.200"
                        rounded="lg"
                        bg="gray.50"
                      >
                        <VStack align="start" gap={3}>
                          {/* Header */}
                          <HStack justify="space-between" w="100%">
                            <VStack align="start" gap={1}>
                              <Text fontWeight="bold" fontSize="lg">
                                {booking.eventType}
                              </Text>
                              <HStack gap={2}>
                                <Badge
                                  colorScheme={getCalendlyStatusColor(
                                    booking.status
                                  )}
                                >
                                  {booking.status.toUpperCase()}
                                </Badge>
                                <Text fontSize="sm" color="gray.600">
                                  {booking.duration} minutes
                                </Text>
                              </HStack>
                            </VStack>
                            <VStack align="end" gap={0}>
                              <Text fontSize="sm" color="gray.600">
                                {scheduledTime.date}
                              </Text>
                              <Text
                                fontSize="sm"
                                fontWeight="medium"
                                color="gray.800"
                              >
                                {scheduledTime.time}
                              </Text>
                            </VStack>
                          </HStack>

                          {/* Details */}
                          <SimpleGrid columns={2} gap={4} w="100%">
                            <VStack align="start" gap={2}>
                              <Text fontSize="sm" color="gray.700">
                                <strong>Attendee:</strong>{" "}
                                {booking.attendeeName}
                              </Text>
                              <Text fontSize="sm" color="blue.600">
                                {booking.attendeeEmail}
                              </Text>
                              {booking.meetingUrl && (
                                <Text fontSize="sm" color="purple.600">
                                  <strong>Meeting:</strong>{" "}
                                  <a
                                    href={booking.meetingUrl}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    Join Zoom
                                  </a>
                                </Text>
                              )}
                            </VStack>

                            <VStack align="start" gap={2}>
                              <Text fontSize="sm" color="gray.700">
                                <strong>Created:</strong> {createdTime.full}
                              </Text>
                              {booking.completedAt && (
                                <Text fontSize="sm" color="green.600">
                                  <strong>Completed:</strong>{" "}
                                  {formatTimestamp(booking.completedAt).full}
                                </Text>
                              )}
                              {booking.cancelledAt && (
                                <Text fontSize="sm" color="red.600">
                                  <strong>Cancelled:</strong>{" "}
                                  {formatTimestamp(booking.cancelledAt).full}
                                </Text>
                              )}
                            </VStack>
                          </SimpleGrid>

                          {/* Notes */}
                          {booking.notes && (
                            <Box bg="blue.50" p={3} rounded="md" w="100%">
                              <Text fontSize="sm" color="blue.800">
                                <strong>Notes:</strong> {booking.notes}
                              </Text>
                            </Box>
                          )}

                          {/* Cancellation Reason */}
                          {booking.cancellationReason && (
                            <Box bg="red.50" p={3} rounded="md" w="100%">
                              <Text fontSize="sm" color="red.800">
                                <strong>Cancellation Reason:</strong>{" "}
                                {booking.cancellationReason}
                              </Text>
                            </Box>
                          )}
                        </VStack>
                      </Box>
                    );
                  })}

                  {mockCalendlyData.length === 0 && (
                    <Box textAlign="center" py={8}>
                      <Text color="gray.500">
                        No Calendly bookings found for this customer.
                      </Text>
                    </Box>
                  )}
                </VStack>
              </Box>
            </Tabs.Content>

            {/* Chain Tab Content */}
            <Tabs.Content value="chain" asChild>
              <Box h="100%" overflowY="hidden" p={6}>
                <VStack align="stretch" gap={4} h="100%">
                  <Box
                    p={4}
                    bg="blue.50"
                    border="1px"
                    borderColor="blue.200"
                    rounded="lg"
                  >
                    <Text
                      fontSize="lg"
                      fontWeight="semibold"
                      color="blue.800"
                      mb={2}
                    >
                      Chain Customers from Same IP Address
                    </Text>
                    <Text fontSize="sm" color="blue.600">
                      Current customer IP range: 192.168.1.x (Toronto, Canada) •
                      Click on any customer row to view their full details
                    </Text>
                  </Box>

                  {/* Chain Customers Table */}
                  <Box
                    flex="1"
                    bg="white"
                    rounded="lg"
                    border="1px"
                    borderColor="gray.200"
                    overflow="hidden"
                  >
                    <Box height="400px" width="100%">
                      <AgGridReact
                        rowData={[
                          {
                            id: "cust_001",
                            name: "Sarah Johnson",
                            email: "sarah.johnson@email.com",
                            phone: "(416) 738-2941",
                            status: "active",
                            stage: "qualified",
                            lastActivity: "2025-01-14T16:30:00Z",
                            totalRequests: 8,
                            sessionDuration: "25 min",
                            source: "Google Ads",
                            creditScore: 720,
                            income: 92000
                          },
                          {
                            id: "cust_002",
                            name: "Michael Chen",
                            email: "m.chen@company.com",
                            phone: "(647) 419-8263",
                            status: "active",
                            stage: "interested",
                            lastActivity: "2025-01-13T14:15:00Z",
                            totalRequests: 12,
                            sessionDuration: "18 min",
                            source: "Facebook",
                            creditScore: 680,
                            income: 78000
                          },
                          {
                            id: "cust_003",
                            name: "Jennifer Davis",
                            email: "jen.davis@gmail.com",
                            phone: "(416) 293-7184",
                            status: "inactive",
                            stage: "cold",
                            lastActivity: "2025-01-10T11:45:00Z",
                            totalRequests: 3,
                            sessionDuration: "8 min",
                            source: "Direct",
                            creditScore: 580,
                            income: 65000
                          },
                          {
                            id: "cust_004",
                            name: "Robert Martinez",
                            email: "robert.m@hotmail.com",
                            phone: "(289) 847-3619",
                            status: "active",
                            stage: "pre_approved",
                            lastActivity: "2025-01-15T09:20:00Z",
                            totalRequests: 15,
                            sessionDuration: "42 min",
                            source: "Referral",
                            creditScore: 750,
                            income: 105000
                          }
                        ]}
                        columnDefs={[
                          {
                            headerName: "Name",
                            field: "name",
                            filter: "agTextColumnFilter",
                            sortable: true,
                            resizable: true,
                            minWidth: 150,
                            maxWidth: 200,
                            cellRenderer: (params: any) => {
                              return (
                                <Text
                                  fontSize="sm"
                                  fontWeight="medium"
                                  color="gray.800"
                                >
                                  {params.value}
                                </Text>
                              );
                            }
                          },
                          {
                            headerName: "Status",
                            field: "status",
                            filter: "agSetColumnFilter",
                            sortable: true,
                            resizable: true,
                            minWidth: 100,
                            maxWidth: 120,
                            cellRenderer: (params: any) => {
                              const getStatusColor = (status: string) => {
                                switch (status) {
                                  case "active":
                                    return "green";
                                  case "inactive":
                                    return "red";
                                  case "pending":
                                    return "orange";
                                  default:
                                    return "gray";
                                }
                              };
                              return (
                                <Badge
                                  colorScheme={getStatusColor(params.value)}
                                  variant="subtle"
                                  size="sm"
                                >
                                  {params.value.toUpperCase()}
                                </Badge>
                              );
                            }
                          },
                          {
                            headerName: "Stage",
                            field: "stage",
                            filter: "agSetColumnFilter",
                            sortable: true,
                            resizable: true,
                            minWidth: 120,
                            maxWidth: 150,
                            cellRenderer: (params: any) => {
                              const getStageColor = (stage: string) => {
                                switch (stage) {
                                  case "qualified":
                                    return "green";
                                  case "interested":
                                    return "blue";
                                  case "pre_approved":
                                    return "purple";
                                  case "cold":
                                    return "gray";
                                  default:
                                    return "gray";
                                }
                              };
                              return (
                                <Badge
                                  colorScheme={getStageColor(params.value)}
                                  variant="outline"
                                  size="sm"
                                >
                                  {params.value.replace("_", " ").toUpperCase()}
                                </Badge>
                              );
                            }
                          },
                          {
                            headerName: "Email",
                            field: "email",
                            filter: "agTextColumnFilter",
                            sortable: true,
                            resizable: true,
                            minWidth: 200,
                            maxWidth: 250,
                            cellRenderer: (params: any) => {
                              return (
                                <Text fontSize="sm" color="gray.700">
                                  {params.value}
                                </Text>
                              );
                            }
                          },
                          {
                            headerName: "Phone",
                            field: "phone",
                            filter: "agTextColumnFilter",
                            sortable: true,
                            resizable: true,
                            minWidth: 130,
                            maxWidth: 160,
                            cellRenderer: (params: any) => {
                              return (
                                <Text fontSize="sm" color="gray.700">
                                  {params.value}
                                </Text>
                              );
                            }
                          },
                          {
                            headerName: "Credit Score",
                            field: "creditScore",
                            filter: "agNumberColumnFilter",
                            sortable: true,
                            resizable: true,
                            minWidth: 110,
                            maxWidth: 140,
                            cellRenderer: (params: any) => {
                              return (
                                <Text
                                  fontSize="sm"
                                  fontWeight="bold"
                                  color="purple.600"
                                >
                                  {params.value}
                                </Text>
                              );
                            }
                          },
                          {
                            headerName: "Income",
                            field: "income",
                            filter: "agNumberColumnFilter",
                            sortable: true,
                            resizable: true,
                            minWidth: 120,
                            maxWidth: 150,
                            cellRenderer: (params: any) => {
                              return (
                                <Text
                                  fontSize="sm"
                                  fontWeight="bold"
                                  color="green.600"
                                >
                                  ${params.value.toLocaleString()}
                                </Text>
                              );
                            }
                          },
                          {
                            headerName: "Requests",
                            field: "totalRequests",
                            filter: "agNumberColumnFilter",
                            sortable: true,
                            resizable: true,
                            minWidth: 90,
                            maxWidth: 120,
                            cellRenderer: (params: any) => {
                              return (
                                <Text fontSize="sm" color="blue.600">
                                  {params.value}
                                </Text>
                              );
                            }
                          },
                          {
                            headerName: "Source",
                            field: "source",
                            filter: "agSetColumnFilter",
                            sortable: true,
                            resizable: true,
                            minWidth: 100,
                            maxWidth: 130,
                            cellRenderer: (params: any) => {
                              return (
                                <Badge variant="outline" size="sm">
                                  {params.value}
                                </Badge>
                              );
                            }
                          },
                          {
                            headerName: "Last Activity",
                            field: "lastActivity",
                            filter: "agDateColumnFilter",
                            sortable: true,
                            resizable: true,
                            minWidth: 140,
                            maxWidth: 180,
                            cellRenderer: (params: any) => {
                              const timestamp = formatTimestamp(params.value);
                              return (
                                <VStack align="start" gap={0}>
                                  <Text fontSize="xs" color="gray.600">
                                    {timestamp.time}
                                  </Text>
                                  <Text fontSize="xs" color="gray.400">
                                    {timestamp.date}
                                  </Text>
                                </VStack>
                              );
                            }
                          }
                        ]}
                        defaultColDef={{
                          sortable: true,
                          filter: true,
                          resizable: true,
                          minWidth: 100,
                          suppressSizeToFit: true,
                          autoHeaderHeight: true
                        }}
                        onGridReady={(event) => {
                          event.api.autoSizeAllColumns();
                        }}
                        onRowClicked={(event) => {
                          // Update selected customer when clicking on a chain customer
                          if (event.data) {
                            setSelectedCustomer({
                              firstName: event.data.name.split(" ")[0],
                              lastName: event.data.name.split(" ")[1] || "",
                              email: event.data.email,
                              phone: event.data.phone,
                              qualificationStatus:
                                event.data.stage === "qualified"
                                  ? "QUALIFIED"
                                  : event.data.stage === "pre_approved"
                                    ? "QUALIFIED"
                                    : event.data.stage === "interested"
                                      ? "PENDING"
                                      : "NOT_QUALIFIED",
                              stage:
                                event.data.stage === "qualified"
                                  ? "CONGRATULATIONS"
                                  : event.data.stage === "pre_approved"
                                    ? "IN_PROGRESS"
                                    : event.data.stage === "interested"
                                      ? "IN_PROGRESS"
                                      : "COMPLETED",
                              step:
                                event.data.stage === "qualified"
                                  ? 7
                                  : event.data.stage === "pre_approved"
                                    ? 5
                                    : event.data.stage === "interested"
                                      ? 3
                                      : 1,
                              income: event.data.income,
                              creditScore: event.data.creditScore,
                              source: event.data.source
                            });
                            // Switch to Summary tab to show the selected customer details
                            setActiveTab("summary");
                          }
                        }}
                        onFirstDataRendered={(params) => {
                          params.api.autoSizeAllColumns();
                        }}
                        onGridSizeChanged={(params) => {
                          params.api.autoSizeAllColumns();
                        }}
                        getRowStyle={(params) => {
                          const isSelected =
                            params.data?.email === selectedCustomer?.email;
                          return {
                            cursor: "pointer",
                            ...(isSelected && { backgroundColor: "#E6F4FF" })
                          };
                        }}
                        animateRows={true}
                        cellSelection={true}
                        enableCharts={true}
                        sideBar={{
                          toolPanels: [
                            {
                              id: "columns",
                              labelDefault: "Columns",
                              labelKey: "columns",
                              iconKey: "columns",
                              toolPanel: "agColumnsToolPanel"
                            },
                            {
                              id: "filters",
                              labelDefault: "Filters",
                              labelKey: "filters",
                              iconKey: "filter",
                              toolPanel: "agFiltersToolPanel"
                            }
                          ],
                          hiddenByDefault: true
                        }}
                        rowSelection={{
                          mode: "singleRow",
                          enableClickSelection: true
                        }}
                        pagination={true}
                        paginationPageSize={10}
                        paginationPageSizeSelector={[5, 10, 20]}
                        paginationAutoPageSize={false}
                        suppressPaginationPanel={false}
                        localeText={{
                          page: "Page",
                          more: "More",
                          to: "to",
                          of: "of",
                          next: "Next",
                          last: "Last",
                          first: "First",
                          previous: "Previous",
                          loadingOoo: "Loading...",
                          noRowsToShow: "No customers to show"
                        }}
                        rowHeight={50}
                        loading={false}
                      />
                    </Box>
                  </Box>
                </VStack>
              </Box>
            </Tabs.Content>

            {/* Referrals Tab Content */}
            <Tabs.Content value="referrals" asChild>
              <Box h="100%" overflowY="auto" p={6}>
                <VStack align="stretch" gap={6}>
                  {/* Referrals Header */}
                  <Box
                    bg="purple.50"
                    border="2px"
                    borderColor="purple.200"
                    rounded="xl"
                    p={6}
                  >
                    <HStack gap={4} mb={4}>
                      <Box fontSize="2xl">🤝</Box>
                      <Box>
                        <Text
                          fontSize="xl"
                          fontWeight="bold"
                          color="purple.800"
                        >
                          Customer Referrals
                        </Text>
                        <Text fontSize="sm" color="purple.600">
                          Track customer referral activity and rewards
                        </Text>
                      </Box>
                    </HStack>

                    <SimpleGrid columns={3} gap={4} mt={4}>
                      <Box
                        bg="white"
                        p={4}
                        rounded="lg"
                        border="1px"
                        borderColor="purple.100"
                      >
                        <Text
                          fontSize="sm"
                          fontWeight="medium"
                          color="gray.600"
                        >
                          Total Referrals Made
                        </Text>
                        <Text
                          fontSize="2xl"
                          fontWeight="bold"
                          color="purple.600"
                        >
                          5
                        </Text>
                      </Box>
                      <Box
                        bg="white"
                        p={4}
                        rounded="lg"
                        border="1px"
                        borderColor="purple.100"
                      >
                        <Text
                          fontSize="sm"
                          fontWeight="medium"
                          color="gray.600"
                        >
                          Successful Conversions
                        </Text>
                        <Text
                          fontSize="2xl"
                          fontWeight="bold"
                          color="green.600"
                        >
                          3
                        </Text>
                      </Box>
                      <Box
                        bg="white"
                        p={4}
                        rounded="lg"
                        border="1px"
                        borderColor="purple.100"
                      >
                        <Text
                          fontSize="sm"
                          fontWeight="medium"
                          color="gray.600"
                        >
                          Rewards Earned
                        </Text>
                        <Text
                          fontSize="2xl"
                          fontWeight="bold"
                          color="orange.600"
                        >
                          $750
                        </Text>
                      </Box>
                    </SimpleGrid>
                  </Box>

                  {/* Referral List */}
                  <Box>
                    <Text fontSize="lg" fontWeight="bold" mb={4}>
                      Referral History
                    </Text>
                    <VStack align="stretch" gap={3}>
                      {/* Referral Item 1 */}
                      <Box
                        bg="white"
                        p={4}
                        rounded="lg"
                        border="1px"
                        borderColor="gray.200"
                        _hover={{ shadow: "md", borderColor: "purple.300" }}
                        transition="all 0.2s"
                      >
                        <HStack justify="space-between">
                          <Box>
                            <HStack gap={3}>
                              <Badge colorScheme="green" size="sm">
                                Converted
                              </Badge>
                              <Text fontWeight="bold">Sarah Johnson</Text>
                            </HStack>
                            <Text fontSize="sm" color="gray.600" mt={1}>
                              sarah.johnson@email.com • Referred on Oct 15, 2025
                            </Text>
                          </Box>
                          <Box textAlign="right">
                            <Text fontSize="sm" color="gray.600">
                              Reward
                            </Text>
                            <Text fontWeight="bold" color="green.600">
                              $250
                            </Text>
                          </Box>
                        </HStack>
                      </Box>

                      {/* Referral Item 2 */}
                      <Box
                        bg="white"
                        p={4}
                        rounded="lg"
                        border="1px"
                        borderColor="gray.200"
                        _hover={{ shadow: "md", borderColor: "purple.300" }}
                        transition="all 0.2s"
                      >
                        <HStack justify="space-between">
                          <Box>
                            <HStack gap={3}>
                              <Badge colorScheme="green" size="sm">
                                Converted
                              </Badge>
                              <Text fontWeight="bold">Michael Chen</Text>
                            </HStack>
                            <Text fontSize="sm" color="gray.600" mt={1}>
                              m.chen@email.com • Referred on Oct 10, 2025
                            </Text>
                          </Box>
                          <Box textAlign="right">
                            <Text fontSize="sm" color="gray.600">
                              Reward
                            </Text>
                            <Text fontWeight="bold" color="green.600">
                              $250
                            </Text>
                          </Box>
                        </HStack>
                      </Box>

                      {/* Referral Item 3 */}
                      <Box
                        bg="white"
                        p={4}
                        rounded="lg"
                        border="1px"
                        borderColor="gray.200"
                        _hover={{ shadow: "md", borderColor: "purple.300" }}
                        transition="all 0.2s"
                      >
                        <HStack justify="space-between">
                          <Box>
                            <HStack gap={3}>
                              <Badge colorScheme="yellow" size="sm">
                                Pending
                              </Badge>
                              <Text fontWeight="bold">David Martinez</Text>
                            </HStack>
                            <Text fontSize="sm" color="gray.600" mt={1}>
                              d.martinez@email.com • Referred on Oct 20, 2025
                            </Text>
                          </Box>
                          <Box textAlign="right">
                            <Text fontSize="sm" color="gray.600">
                              Potential Reward
                            </Text>
                            <Text fontWeight="bold" color="orange.600">
                              $250
                            </Text>
                          </Box>
                        </HStack>
                      </Box>

                      {/* Referral Item 4 */}
                      <Box
                        bg="white"
                        p={4}
                        rounded="lg"
                        border="1px"
                        borderColor="gray.200"
                        _hover={{ shadow: "md", borderColor: "purple.300" }}
                        transition="all 0.2s"
                      >
                        <HStack justify="space-between">
                          <Box>
                            <HStack gap={3}>
                              <Badge colorScheme="green" size="sm">
                                Converted
                              </Badge>
                              <Text fontWeight="bold">Emily Wong</Text>
                            </HStack>
                            <Text fontSize="sm" color="gray.600" mt={1}>
                              e.wong@email.com • Referred on Sep 28, 2025
                            </Text>
                          </Box>
                          <Box textAlign="right">
                            <Text fontSize="sm" color="gray.600">
                              Reward
                            </Text>
                            <Text fontWeight="bold" color="green.600">
                              $250
                            </Text>
                          </Box>
                        </HStack>
                      </Box>

                      {/* Referral Item 5 */}
                      <Box
                        bg="white"
                        p={4}
                        rounded="lg"
                        border="1px"
                        borderColor="gray.200"
                        _hover={{ shadow: "md", borderColor: "purple.300" }}
                        transition="all 0.2s"
                      >
                        <HStack justify="space-between">
                          <Box>
                            <HStack gap={3}>
                              <Badge colorScheme="red" size="sm">
                                Expired
                              </Badge>
                              <Text fontWeight="bold">Robert Taylor</Text>
                            </HStack>
                            <Text fontSize="sm" color="gray.600" mt={1}>
                              r.taylor@email.com • Referred on Sep 15, 2025
                            </Text>
                          </Box>
                          <Box textAlign="right">
                            <Text fontSize="sm" color="gray.600">
                              No Reward
                            </Text>
                            <Text fontWeight="bold" color="gray.400">
                              -
                            </Text>
                          </Box>
                        </HStack>
                      </Box>
                    </VStack>
                  </Box>

                  {/* Referral Program Info */}
                  <Box
                    bg="blue.50"
                    border="1px"
                    borderColor="blue.200"
                    rounded="lg"
                    p={4}
                  >
                    <HStack gap={3}>
                      <Box fontSize="xl">💡</Box>
                      <Box>
                        <Text fontWeight="bold" color="blue.800">
                          Referral Program Details
                        </Text>
                        <Text fontSize="sm" color="blue.700" mt={1}>
                          Earn $250 for each successful referral that converts
                          to a customer. Referrals must complete their purchase
                          within 60 days to qualify for rewards.
                        </Text>
                      </Box>
                    </HStack>
                  </Box>
                </VStack>
              </Box>
            </Tabs.Content>

            {/* Ads Tab Content */}
            <Tabs.Content value="ads" asChild>
              <Box h="100%" overflowY="auto" p={6}>
                <AdsTab campaigns={mockAdCampaigns} />
              </Box>
            </Tabs.Content>

            {/* Summary Tab Content */}
            <Tabs.Content value="summary" asChild>
              <Box h="100%" overflowY="auto" p={6}>
                <VStack align="stretch" gap={6}>
                  {/* Journey Summary Stats */}
                  <SimpleGrid columns={4} gap={4}>
                    <Box
                      p={4}
                      bg="blue.50"
                      border="1px"
                      borderColor="blue.200"
                      rounded="lg"
                      textAlign="center"
                    >
                      <Text fontSize="2xl" fontWeight="bold" color="blue.600">
                        {journeyPoints.reduce((sum, p) => sum + p.requests, 0)}
                      </Text>
                      <Text fontSize="sm" color="blue.700">
                        Total Requests
                      </Text>
                    </Box>
                    <Box
                      p={4}
                      bg="green.50"
                      border="1px"
                      borderColor="green.200"
                      rounded="lg"
                      textAlign="center"
                    >
                      <Text fontSize="2xl" fontWeight="bold" color="green.600">
                        {journeyPoints.length}
                      </Text>
                      <Text fontSize="sm" color="green.700">
                        Journey Steps
                      </Text>
                    </Box>
                    <Box
                      p={4}
                      bg="purple.50"
                      border="1px"
                      borderColor="purple.200"
                      rounded="lg"
                      textAlign="center"
                    >
                      <Text fontSize="2xl" fontWeight="bold" color="purple.600">
                        {journeyPoints.length}
                      </Text>
                      <Text fontSize="sm" color="purple.700">
                        Toronto Neighbourhoods
                      </Text>
                    </Box>
                    <Box
                      p={4}
                      bg="orange.50"
                      border="1px"
                      borderColor="orange.200"
                      rounded="lg"
                      textAlign="center"
                    >
                      <Text fontSize="2xl" fontWeight="bold" color="orange.600">
                        {Math.floor(journeyPoints.length * 1.2)}h {Math.floor((journeyPoints.length * 1.2 % 1) * 60)}m
                      </Text>
                      <Text fontSize="sm" color="orange.700">
                        Journey Duration
                      </Text>
                    </Box>
                  </SimpleGrid>

                  {/* Map Visualization */}
                  <Box
                    p={4}
                    bg="white"
                    border="1px"
                    borderColor="gray.200"
                    rounded="lg"
                  >
                    {/* Enhanced Map Header */}
                    <Box
                      mb={6}
                      p={4}
                      bg="gradient.to-r"
                      bgGradient="linear(to-r, indigo.50, purple.50)"
                      rounded="xl"
                      border="2px"
                      borderColor="indigo.200"
                    >
                      <HStack justify="space-between">
                        <HStack gap={3}>
                          <Box
                            fontSize="2xl"
                            bg="white"
                            p={2}
                            rounded="lg"
                            shadow="md"
                          >
                            🗺️
                          </Box>
                          <Box>
                            <Text
                              fontSize="xl"
                              fontWeight="bold"
                              color="gray.800"
                            >
                              Customer Journey Map
                            </Text>
                            <Text fontSize="sm" color="gray.600">
                              Interactive geographic visualization across
                              Toronto
                            </Text>
                          </Box>
                        </HStack>
                        <HStack gap={2}>
                          <Badge
                            colorScheme="purple"
                            fontSize="sm"
                            px={3}
                            py={1}
                          >
                            📍 {journeyPoints.length} Locations
                          </Badge>
                          <Badge colorScheme="blue" fontSize="sm" px={3} py={1}>
                            ⏱ {(journeyPoints.length * 1.2).toFixed(1)} Hours
                          </Badge>
                          <Badge
                            colorScheme="green"
                            fontSize="sm"
                            px={3}
                            py={1}
                          >
                            📊 {journeyPoints.reduce((sum, p) => sum + p.requests, 0)} Interactions
                          </Badge>
                        </HStack>
                      </HStack>
                    </Box>

                    {/* Enhanced Toronto Map Container */}
                    <Box
                      w="100%"
                      h="500px"
                      border="3px"
                      borderColor="indigo.300"
                      rounded="2xl"
                      overflow="hidden"
                      shadow="2xl"
                      position="relative"
                    >
                      {/* Interactive Map Legend */}
                      <Box
                        position="absolute"
                        top="4"
                        right="4"
                        bg="white"
                        p={4}
                        rounded="xl"
                        shadow="xl"
                        zIndex={1000}
                        border="2px"
                        borderColor="gray.200"
                        maxW="200px"
                      >
                        <Text
                          fontSize="sm"
                          fontWeight="bold"
                          mb={3}
                          color="gray.700"
                        >
                          Map Legend
                        </Text>
                        <VStack align="start" gap={2}>
                          <HStack gap={2}>
                            <Box
                              w={4}
                              h={4}
                              bg="gradient.to-br"
                              bgGradient="linear(to-br, green.400, green.600)"
                              rounded="full"
                              shadow="sm"
                            />
                            <Text fontSize="xs" color="gray.600">
                              Start Location
                            </Text>
                          </HStack>
                          <HStack gap={2}>
                            <Box
                              w={4}
                              h={4}
                              bg="gradient.to-br"
                              bgGradient="linear(to-br, blue.400, blue.600)"
                              rounded="full"
                              shadow="sm"
                            />
                            <Text fontSize="xs" color="gray.600">
                              Journey Points
                            </Text>
                          </HStack>
                          <HStack gap={2}>
                            <Box
                              w={4}
                              h={4}
                              bg="gradient.to-br"
                              bgGradient="linear(to-br, red.400, red.600)"
                              rounded="full"
                              shadow="sm"
                            />
                            <Text fontSize="xs" color="gray.600">
                              Final Location
                            </Text>
                          </HStack>
                          <HStack gap={2}>
                            <Box
                              w={12}
                              h={1}
                              bg="gradient.to-r"
                              bgGradient="linear(to-r, blue.300, purple.300)"
                              rounded="full"
                            />
                            <Text fontSize="xs" color="gray.600">
                              Journey Path
                            </Text>
                          </HStack>
                        </VStack>
                        <Text
                          fontSize="2xs"
                          color="gray.500"
                          mt={3}
                          fontStyle="italic"
                        >
                          Click markers for details
                        </Text>
                      </Box>
                      <MapContainer
                        key={selectedCustomer?.emailAddress || selectedCustomer?.zid || "default"}
                        center={[43.6532, -79.3832]} // Toronto center coordinates
                        zoom={12}
                        style={{ height: "100%", width: "100%" }}
                        scrollWheelZoom={true}
                      >
                        <TileLayer
                          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                        />

                        {/* Journey Points Data */}
                        {(() => {
                          // Create path coordinates from customer-specific journey
                          const pathCoordinates: [number, number][] =
                            journeyPoints.map(
                              (point) =>
                                [point.lat, point.lng] as [number, number]
                            );

                          return (
                            <>
                              {/* Journey Path */}
                              <Polyline
                                positions={pathCoordinates}
                                color="#3B82F6"
                                weight={4}
                                opacity={0.8}
                                dashArray="10, 10"
                              />

                              {/* Journey Markers */}
                              {journeyPoints.map((location) => (
                                <Marker
                                  key={location.ip}
                                  position={[location.lat, location.lng]}
                                  icon={createNumberedIcon(
                                    location.step,
                                    location.step === 1,
                                    location.step === journeyPoints.length
                                  )}
                                >
                                  <Popup>
                                    <div style={{ minWidth: "200px" }}>
                                      <div
                                        style={{
                                          display: "flex",
                                          justifyContent: "space-between",
                                          alignItems: "center",
                                          marginBottom: "8px"
                                        }}
                                      >
                                        <strong style={{ color: "#3B82F6" }}>
                                          Step {location.step}
                                        </strong>
                                        <span
                                          style={{
                                            fontSize: "12px",
                                            color: "#666"
                                          }}
                                        >
                                          {
                                            formatTimestamp(location.timestamp)
                                              .time
                                          }
                                        </span>
                                      </div>
                                      <div style={{ marginBottom: "4px" }}>
                                        <strong>
                                          {location.city}, {location.country}
                                        </strong>
                                      </div>
                                      <div
                                        style={{
                                          fontSize: "12px",
                                          color: "#666"
                                        }}
                                      >
                                        IP: {location.ip}
                                      </div>
                                      <div
                                        style={{
                                          fontSize: "12px",
                                          color: "#666"
                                        }}
                                      >
                                        {location.requests} requests
                                      </div>
                                      <div
                                        style={{
                                          fontSize: "11px",
                                          color: "#999"
                                        }}
                                      >
                                        {location.lat.toFixed(4)},{" "}
                                        {location.lng.toFixed(4)}
                                      </div>
                                      <div
                                        style={{
                                          fontSize: "11px",
                                          color: "#999"
                                        }}
                                      >
                                        {
                                          formatTimestamp(location.timestamp)
                                            .date
                                        }
                                      </div>
                                    </div>
                                  </Popup>
                                </Marker>
                              ))}
                            </>
                          );
                        })()}
                      </MapContainer>
                    </Box>

                    {/* Enhanced Journey Timeline Below Map */}
                    <Box mt={6}>
                      <LocationTimeline
                        items={journeyPoints.map((point, index) => {
                          // Generate varied device/browser combinations
                          const devices = [
                            { device: "iPhone 15 Pro", browser: "Safari 17.2" },
                            { device: "Samsung Galaxy S24", browser: "Chrome 120" },
                            { device: "Google Pixel 8", browser: "Chrome 120" },
                            { device: "MacBook Pro", browser: "Safari 17.2" },
                            { device: "Windows Desktop", browser: "Edge 120" },
                          ];
                          const deviceInfo = devices[index % devices.length];
                          const durations = ["15 min", "25 min", "30 min", "35 min", "40 min", "45 min", "55 min"];
                          const pagesViewed = Math.max(2, Math.min(8, Math.floor(point.requests * 0.6)));
                          const engagementScore = Math.min(98, Math.max(45, 50 + point.requests * 4));
                          
                          return {
                            step: point.step,
                            location: point.city,
                            ip: point.ip,
                            requests: point.requests,
                            timestamp: point.timestamp,
                            duration: durations[index % durations.length],
                            details: {
                              device: deviceInfo.device,
                              browser: deviceInfo.browser,
                              pagesViewed,
                              engagementScore
                            }
                          };
                        })}
                      />
                    </Box>
                  </Box>
                </VStack>
              </Box>
            </Tabs.Content>
          </Box>
        </Tabs.Root>
      </Box>
    </Box>
  );
}

export default CustomerDetailModel;
